import styled from "styled-components";

export const ConfirmModalText = styled.div`
    line-height: 30px;
    text-align: center;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    height: 90%;
    justify-content: center;
    font-size: 16px !important;
    padding: 24px 16px;
`;
